import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { HUNDRED_BRICKS_PLATFORM_SECTION_MODELS } from '@constants';
import { Paragraph } from '@components/Styled';
import Icons from '../Icons';
import { ModelChipWrapper, OptionButton } from './ModelChip.style';
const ModelChip = (props) => {
    const { currentModel, onChangeModel, platformSectionName } = props;
    const changeModelHandler = (model) => {
        if (currentModel !== model)
            onChangeModel(model);
    };
    return (_jsxs(ModelChipWrapper, { children: [_jsx(Paragraph, { children: "Vista" }), _jsx(OptionButton, { id: `${platformSectionName}-modelOption-shortCards`, type: "button", isSelected: currentModel === HUNDRED_BRICKS_PLATFORM_SECTION_MODELS.list, onClick: () => changeModelHandler(HUNDRED_BRICKS_PLATFORM_SECTION_MODELS.list), children: _jsx(Icons.QueueList, { outlined: true }) }), _jsx(OptionButton, { id: `${platformSectionName}-modelOption-fullCards`, type: "button", isSelected: currentModel === HUNDRED_BRICKS_PLATFORM_SECTION_MODELS.grid, onClick: () => changeModelHandler(HUNDRED_BRICKS_PLATFORM_SECTION_MODELS.grid), children: _jsx(Icons.Squares2x2, { outlined: true }) })] }));
};
export default ModelChip;
